<template>
  <div :class="active?'is-active':''" class="NumberRange el-date-editor el-range-editor el-input__inner el-date-editor--daterange el-range-editor--small">
    <i class="el-input__icon el-range__icon" :class="useSvg?'':rangeIcon">
      <svg-icon style="color:#c0c4cc;margin-top:-2px;width:12px;height:12px;" v-if="useSvg" :icon-class="rangeIcon"></svg-icon>
    </i>
    <input 
      type="number"
      min="-1"
      :max="value[1]"
      v-model.number="value[0]" 
      autocomplete="off"
      class="el-range-input"
      @focus="focus"
      @blur="blur">
    <span class="el-range-separator">-</span>
    <input 
      type="number" 
      :min="value[0]"
      v-model.number="value[1]" 
      autocomplete="off"
      class="el-range-input"
      @focus="focus"
      @blur="blur">
    <i class="el-input__icon el-range__close-icon" 
      :class=" value.length > 0 && value[0] !== '' && value[1] !== '' ?'el-icon-circle-close':''"
      @click="cleanRange">
    </i>
  </div>
</template>
<script>
export default {
  name: 'NumberRange',
  props: {
    range: undefined,
    dataType: undefined
  },
  data() {
    return {
      value: this.range,
      active: false,
      iconMap: {
      },
      useSvg: false
    }
  },
  computed: {
    rangeIcon() {
      if (this.dataType.indexOf('ID') > -1) {
        this.useSvg = true
        return 'ID'
      } else if (this.dataType.indexOf('数量') > -1) {
        this.useSvg = true
        return 'count'
      } else if (this.dataType.indexOf('单价') > -1) {
        this.useSvg = true
        return 'money'
      } else if (this.dataType.indexOf('金额') > -1) {
        this.useSvg = true
        return 'money'
      } else {
        this.useSvg = false
        return 'el-icon-location-outline'
      }
    }
  },
  watch: {
    range(newVal) {
      this.value = newVal
    }
  },
  methods: {
    cleanRange() {
      this.$emit('cleanRange')
    },
    focus() {
      this.active = true
    },
    blur() {
      this.active = false
    }
  }
}
</script>
<style lang="scss" scoped>
  .NumberRange{
    .el-range__close-icon{
      display: none;
    }
    &:hover .el-range__close-icon{
      display: block;
    }
  }
</style>
